/**
 * Generic error class. All errors thrown by TMR should employ this
 *
 * The getters `message`, `substitutions` and `suppressStateErrorHandler` have
 * special meaning and can be overridden.
 *
 * @example <caption>Definition</caption>
 *
 * // Definition of a new custom error: a factory that returns a class extending TmrError.
 * export const factory = ['MyCustomError', function(TmrError) { 'ngInject';
 *
 *   return class MyCustomError extends TmrError {
 *     // Set localizable error message thus.
 *     constructor(message = 'MY.CUSTOM.ERROR.MESSAGE', ...params) {
 *       super(message, ...params);
 *     }
 *   }
 * }];
 *
 * @example <caption>Usage</caption>
 *
 * function myService(MyCustomError) { 'ngInject';
 *   // Throw like any other error
 *   throw new MyCustomError();
 * }
 *
 * @type {TmrError}
 */
class TmrError extends Error {
  constructor(message = 'ERROR.UNKNOWN', ...params) {
    super(message, ...params)

    this.name = this.constructor.name
  }

  /** Optional translation variables used by the error message */
  get substitions() {
    return {}
  }

  /** Used in {@link tmrErrorRun}. Override to true in extending errors to hide cruft from errors in */
  get suppressStateErrorHandler() {
    return false
  }
}

/**
 * Factory for generic TMR errors
 *
 * @type {ngFactory}
 */
export const factory = ['TmrError', () => TmrError]

/**
 * Registers a custom error handler for the state system.
 *
 * Basically shows a message to the user if available.
 *
 * @type {ngRun}
 * @see TmrExceptionHandler
 */
function tmrErrorRun($state, TmrToast) {
  'ngInject'
  let _defaultErrorHandler = $state._defaultErrorHandler
  $state.defaultErrorHandler($error$ => {
    TmrToast.exception($error$)

    // Determine if should pass back to UI Router default error handler or eat the error.
    // detail is the error that canceled the transition, and is added by UI-Router;
    // while suppressStateErrorHandler is an optional property of TmrErrors
    if (!$error$.detail.suppressStateErrorHandler) _defaultErrorHandler($error$)
  })
}

export { tmrErrorRun as run }
